import { CoachSessionRemarkV2, formatCoachSessionRemarkV2Label, SessionZoom } from '@airreading/common/data';
import clsx from 'clsx';
import { Temporal } from 'temporal-polyfill';

interface EventDisplayTagBadgeProps {
  tag: CoachSessionRemarkV2 | null;
  session?: {
    zoom?: SessionZoom | null;
    startInstant?: Temporal.Instant;
    endInstant?: Temporal.Instant;
    addedCoachSessionRemarksV2?: CoachSessionRemarkV2[];
  };
}

const baseClassName = 'px-2 py-1 rounded-[6px] text-[14px] leading-[22px] text-center ';

const CoachSessionRemarkBackgroundColorMap: Record<CoachSessionRemarkV2, string> = {
  [CoachSessionRemarkV2.subClass]: 'bg-[#E5F3FE] text-air-blue',
  [CoachSessionRemarkV2.subClassWithin12Hours]: 'bg-[#E6EBFF] text-air-purple',
  [CoachSessionRemarkV2.canceled]: 'bg-[#E0E6EE] text-[#424B58]',
  [CoachSessionRemarkV2.canceledWithin12Hours]: 'bg-[#E0E6EE] text-[#424B58]',
  [CoachSessionRemarkV2.lateStart]: 'bg-[#E0E6EE] text-[#424B58]',
  [CoachSessionRemarkV2.endEarly]: 'bg-[#E0E6EE] text-[#424B58]',
  [CoachSessionRemarkV2.tns]: 'bg-[#E0E6EE] text-[#424B58]',
};

export function EventDisplayTagBadge({ tag, session }: EventDisplayTagBadgeProps) {
  if (!tag) return null;

  return (
    <div className={clsx(baseClassName, CoachSessionRemarkBackgroundColorMap[tag])}>
      {formatCoachSessionRemarkV2Label(tag, session)}
    </div>
  );
}
